/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import InfoCard from './InfoCard'

const styles = theme => ({})

class InfoCards extends PureComponent {
    render() {
        const { classes, infoCards } = this.props

        console.log('infoCards', infoCards)

        return (
            <>
                {infoCards.map((card, key) => (
                    <InfoCard title={card.title} body={card.description} image={card.image_url} icon={card.icon} url={card.link_url} key={key} />
                ))}
            </>
        )
    }
}

export default withStyles(styles)(InfoCards)
